// extracted by mini-css-extract-plugin
export default {"container":"promotionTrackedLinksContent_container__e-jul","wrapper":"promotionTrackedLinksContent_wrapper__9r0cB"};